import { useEffect, useRef, useState } from "react";
import { Button, Col, Card, Row, Layout, Typography, Tag } from "antd";
import changeHeight from "../../../data/changeHeight";
import { Content } from "antd/es/layout/layout";

const { Title, Text } = Typography;

const ResultPaginaPrincipalParte1 = ({ datos, onClick, pricePremium, priceBasic }) => {
    const refResult = useRef(0);
    const [descuento, setDescuento] = useState(0);
    const [noAseguradora, setNoAseguradora] = useState(false);

    useEffect(() => {
        if (datos.procedencia === "NoSeguro") {
            setNoAseguradora(true);
        } else {
            let descuento;
            if (datos.procedencia === "Banco") {
                descuento = datos.importe * 0.7
            } else {
                descuento = datos.importe * 0.85
            }
            if (!Number.isInteger(descuento)) {
                descuento = descuento.toFixed(2);
            }
            setDescuento(descuento);
        }

    }, [datos.procedencia, datos.importe])

    // Observer para redimensionar
    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.target === refResult.current) {
                    changeHeight(entry.target.clientHeight);
                    break;
                }
            }
        });

        resizeObserver.observe(refResult.current);

        return () => {
            if (refResult.current) {
                resizeObserver.unobserve(refResult.current);
            }
        };
    }, []);

    return (
        <>
            <div ref={refResult}>
                {noAseguradora ? (
                    // Renderizar contenido cuando noAseguradora sea true

                    <Layout style={{ backgroundColor: 'white', paddingBottom: '20px' }} >
                        <Content style={{ marginLeft: 20, marginRight: 20 }}>
                            <h1>¡Calculo realizado!</h1>
                            <p><b>Esto es lo que pagarás de forma anual por su seguro de vida</b></p>
                            <Row justify={'center'} align={"middle"} gutter={[40, 20]} style={{ marginTop: 40, marginBottom: 40 }}>
                                <Col xs={24} md={20} lg={10} xl={8}>
                                    <Card>
                                        <Row align={'middle'} justify={'center'}>
                                            <Col>
                                                <h1 style={{ marginBottom: -5 }}>{priceBasic}€</h1>
                                            </Col>
                                        </Row>
                                        <Row align={'middle'} justify={'center'}>
                                            <Col>
                                                <h2 style={{ fontFamily: '"Roboto",sans-serif' }}>Fallecimiento</h2>
                                                <span style={{ fontFamily: '"Roboto",sans-serif', color: '#a2a5b9' }}>Por cualquier causa</span>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                                <Col xs={24} md={20} lg={10} xl={8}>
                                    <Card>
                                        <Row align={'middle'} justify={'center'}>
                                            <Col>
                                                <h1 style={{ marginBottom: -5 }}>{pricePremium}€</h1>
                                            </Col>
                                        </Row>
                                        <Row align={'middle'} justify={'center'}>
                                            <Col>
                                                <h2 style={{ fontFamily: '"Roboto",sans-serif' }}>Fallecimiento + IPA</h2>
                                                <span style={{ fontFamily: '"Roboto",sans-serif', color: '#a2a5b9' }}>Incapacidad Permanente Absoluta</span>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: '15px' }}>
                                <Col span={24}>
                                    <Button type="primary" style={{ width: '100%' }} key="console" href='tel:+34919993131'>
                                        Llamar a Coventia
                                    </Button>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: '15px' }}>
                                <Col span={24}>
                                    <Button type="primary" style={{ width: '100%' }} key="console" target='_blank' href='https://meetings-eu1.hubspot.com/santiago-gatti'>
                                        Concertar una cita
                                    </Button>
                                </Col>
                            </Row>
                        </Content>
                    </Layout>

                ) : (
                    // Renderizar contenido cuando noAseguradora sea false (Rediseñado)
                    <div style={{ padding: '2rem' }}>
                         <Card bordered={false} style={{ textAlign: 'center', background: '#f0f2f5', borderRadius: '8px', padding: '20px' }}>
                            <Title level={4} style={{ color: '#5a5a5a' }}>¡Genial! ¡Es hora de ahorrar!</Title>
                            <Row gutter={16} justify="center" align="middle" style={{ marginTop: '20px', marginBottom: '20px' }}>
                                <Col>
                                    <Text style={{ fontSize: '16px', color: '#8c8c8c' }}>Precio Anterior:</Text>
                                    <Text delete style={{ fontSize: '18px', marginLeft: '8px', color: '#8c8c8c' }}>{datos.importe}€</Text>
                                </Col>
                                <Col>
                                    <Tag color="orange" style={{ fontSize: '16px', padding: '5px 10px', marginLeft: '15px' }}>
                                        Ahorro del {datos.procedencia === "Banco" ? '30%' : '15%'}
                                    </Tag>
                                </Col>
                            </Row>
                            <Text style={{ fontSize: '18px', display: 'block', marginBottom: '10px' }}>Tu nuevo precio anual con Caser:</Text>
                            <Title level={2} style={{ color: '#EC7A08', margin: '0 0 20px 0' }}>{descuento}€</Title>
                            <Text style={{ display: 'block', marginTop: '20px', marginBottom: '20px', color: '#5a5a5a' }}>
                                Puedes continuar con el formulario para obtener un presupuesto detallado sin ningún compromiso.
                            </Text>
                            <Button style={{ width: "80%", height: "40px", marginTop: '10px' }} type='primary' onClick={onClick}>Generar presupuesto</Button>
                        </Card>
                    </div>
                )}
            </div>
        </>


    );

}

export default ResultPaginaPrincipalParte1;